const getContainerPadding = (container: HTMLDivElement) => {
	const styles = window.getComputedStyle(container);
	return parseInt(styles.paddingLeft, 10) || 0;
};

const getAllCards = (container: HTMLDivElement): HTMLElement[] => {
	const cards = container.querySelectorAll<HTMLElement>(
		'[data-testid^="media-hit-"], [data-testid="media-hit-loading"]',
	);
	if (cards.length > 0) return Array.from(cards);
	return Array.from(container.children).filter((child): child is HTMLElement => child instanceof HTMLElement);
};

const getCardPosition = (card: HTMLElement, container: HTMLDivElement): number => {
	const containerRect = container.getBoundingClientRect();
	const cardRect = card.getBoundingClientRect();
	return cardRect.left - containerRect.left;
};

const findNextCard = (cards: HTMLElement[], container: HTMLDivElement, paddingLeft: number): HTMLElement | null => {
	let nextCard: HTMLElement | null = null;
	let minDistance = Infinity;

	for (const card of cards) {
		const position = getCardPosition(card, container);
		if (position > paddingLeft) {
			const distance = position - paddingLeft;
			if (distance < minDistance) {
				minDistance = distance;
				nextCard = card;
			}
		}
	}

	return nextCard;
};

const findPreviousCard = (cards: HTMLElement[], container: HTMLDivElement, paddingLeft: number): HTMLElement | null => {
	let previousCard: HTMLElement | null = null;
	let maxPosition = -Infinity;

	for (const card of cards) {
		const position = getCardPosition(card, container);
		if (position < paddingLeft && position > maxPosition) {
			maxPosition = position;
			previousCard = card;
		}
	}

	return previousCard;
};

export const calculateScrollDistance = (container: HTMLDivElement, direction: 'left' | 'right'): number => {
	const cards = getAllCards(container);
	if (cards.length === 0) return 0;

	const paddingLeft = getContainerPadding(container);

	if (direction === 'right') {
		const nextCard = findNextCard(cards, container, paddingLeft);
		if (nextCard) {
			return getCardPosition(nextCard, container) - paddingLeft;
		}
		const maxScroll = container.scrollWidth - container.clientWidth;
		return maxScroll - container.scrollLeft;
	}

	const previousCard = findPreviousCard(cards, container, paddingLeft);
	if (previousCard) {
		return getCardPosition(previousCard, container) - paddingLeft;
	}
	return -container.scrollLeft;
};

export const calculateButtonStates = (container: HTMLDivElement) => {
	const hasOverflow = container.scrollWidth > container.clientWidth;

	if (!hasOverflow) {
		return { canScrollLeft: false, canScrollRight: false, hasOverflow: false };
	}

	const { scrollLeft, scrollWidth, clientWidth } = container;
	const maxScroll = scrollWidth - clientWidth;

	return {
		canScrollLeft: scrollLeft > 0.5,
		canScrollRight: scrollLeft < maxScroll - 0.5,
		hasOverflow: true,
	};
};
